import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { getFormValues, change } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { SelectField } from 'src/jbc-front/components/Form';
import { getLabeledDays } from 'src/reducers/selectOptions';
import { PAYROLL_RULES_GROUP_FORM } from 'src/constants/FormNames';

import { HalfContainer } from '../styles';
import { getClosingDaySecondHalf, calculatePaymentDateOptions } from '../utils';

const FirstHalfSetting = ({ hasConfirmedPays, closingDay, paymentMonthType, dispatch, firstHalfStartDate, days, closingDaySecondHalf }) => {
  const [paymentDaysOptions, setPaymentDaysOptions] = useState([]);
  const { t } = useTranslation();
  const isNextMonth = paymentMonthType === 'next_month';
  const isEndOfMonth = moment()
    .endOf('month')
    .get('D');

  useEffect(
    () => {
      const options = {
        startDay: isNextMonth ? (closingDay + 1 > isEndOfMonth ? 1 : closingDay + 1) : firstHalfStartDate,
        endDay: isNextMonth ? closingDaySecondHalf : closingDay,
        isSecondHalf: false,
        isNextMonth
      };
      const newPaymentDate = calculatePaymentDateOptions(options, paymentMonthType);
      setPaymentDaysOptions(newPaymentDate);
    },
    [paymentMonthType, closingDay, firstHalfStartDate]
  );

  useEffect(
    () => {
      dispatch(change(PAYROLL_RULES_GROUP_FORM, 'closingDaySecondHalf', getClosingDaySecondHalf(firstHalfStartDate)));
    },
    [firstHalfStartDate]
  );

  return (
    <HalfContainer>
      <h3>{t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.first_half')}</h3>
      <SelectField
        name="firstHalfStartDate"
        label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.start')}
        options={days}
        required
        disabled={hasConfirmedPays}
      />
      <SelectField
        name="closingDay"
        options={days}
        required
        label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.first_half_cut_off_date')}
        disabled={hasConfirmedPays}
      />
      <SelectField
        name="paymentDay"
        options={paymentDaysOptions}
        required
        label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.first_half_payment_date')}
        disabled={hasConfirmedPays}
      />
    </HalfContainer>
  );
};

const mapStateToProps = state => ({
  days: getLabeledDays(state),
  hasConfirmedPays: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'hasConfirmedPays'),
  closingDay: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'closingDay'),
  closingDaySecondHalf: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'closingDaySecondHalf'),
  paymentMonthType: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'paymentMonthType'),
  firstHalfStartDate: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'firstHalfStartDate')
});

export default connect(mapStateToProps)(FirstHalfSetting);
